import { Typography } from '@montugroup/design-system';
import { TextContainer } from './States.styles';

export const ScriptValidOOS = () => {
  return (
    <TextContainer data-testid="pharmacist-escript-script-valid-oos">
      <Typography variant="subtitle1" fontWeight={600} sx={(theme) => ({ marginBottom: theme.spacing(6) })}>
        Out of stock
      </Typography>

      <Typography>This medication is currently out of stock.</Typography>
      <Typography>
        Communications have been sent to your customer to sign up with uMeds, so we can keep them updated on
        availability.
      </Typography>
    </TextContainer>
  );
};
